import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutView from '@/views/AboutView.vue'
import ProductsView from "@/views/ProductsView.vue"
import LoginView from '@/views/LoginView.vue'
import { component } from 'vue/types/umd'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AboutView,
    meta: {requiresAuth:true}
  },
  {
    path: "/login",
    name:"Login",
    component: LoginView,
  },
  {
    path: "/forgotpassword",
    name: "Forgot",
    component: ()=>import("@/views/ForgotPassword.vue")
  },
  {
    path: "/recoverypassword",
    name: "Recovery",
    component: ()=>import("@/views/RecoveryPassword.vue")
  },
  {
    path:"/profile",
    name:"profile",
    component: ()=>import("@/views/ProfileView.vue"),
    meta: {requiresAuth:true}
  },
  {
    path: '/configs',
    name: 'configs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Config" */ '@/views/ConfigsView.vue'),
    //protected route
    meta: {requiresAuth:true}
  },
  {
    path: "/products",
    name:"products",
    component: ProductsView,
    props: true,
    //protected route
    meta: {requiresAuth:true}
  },
  {
    path: "/contatos",
    name: "contatos",
    component: ()=>import('@/views/ContatosView.vue'),
    props: true,
    meta: { requiresAuth:true}
  },
  {
    path:"/terms",
    name:"terms",
    component: ()=>import('@/views/TermsOfUseView.vue'),
  },
  {
    path: "/privacy",
    name: "privacy",  
    component : ()=> import('@/views/PrivacyView.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  
  const isAuthenticated: boolean = JSON.parse(localStorage.getItem('isAuth') || 'false')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isAuthenticated && to.name !=="Login") {
      next({
        path: '/login',
        // query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }

    
})

export default router
